
import { Users } from "lucide-react";
import { ReferralFriend } from "@/hooks/useReferrals";
import FriendCard from "./FriendCard";

interface ReferredFriendsListProps {
  referredFriends: ReferralFriend[];
}

const ReferredFriendsList = ({ referredFriends }: ReferredFriendsListProps) => {
  return (
    <div className="mb-4">
      <h4 className="font-medium text-[#4A607B] mb-3 flex items-center">
        <Users className="mr-2 h-4 w-4" />
        Friends You've Invited
      </h4>
      
      {referredFriends.length > 0 ? (
        <div className="space-y-2">
          {referredFriends.map((friend) => (
            <FriendCard key={friend.id} friend={friend} />
          ))}
        </div>
      ) : (
        <div className="text-center p-6 border border-dashed border-gray-200 rounded-lg">
          <p className="text-[#4A5568]">You haven't invited any friends yet</p>
          <p className="text-sm text-[#718096] mt-1">
            Share your referral link to get started
          </p>
        </div>
      )}
    </div>
  );
};

export default ReferredFriendsList;
